// Add your custom JS here.





var controller = new ScrollMagic.Controller();

// build tween

//var tween = TweenMax.from("#cita-taller", 0.5, {autoAlpha: 0, scale: 0.7});



(function($){

    //var metaSiteUrl = document.querySelector('meta[name="site-url"]');
    
     // var siteURL = metaSiteUrl.content;
      

  // Ejemplo: Cambia el href de un elemento con la clase "mi-clase"
  /*var elementos = document.querySelectorAll('.mi-clase');
  elementos.forEach(function(elemento) {
    elemento.href = siteURL + '/ruta-adicional';
  });*/
   // var siteurlServicios = siteURL + '/servicios';
   // $('.enlaceservicios a.dropdown-toggle').attr('href', siteurlServicios);

    $('.dropdownkkkkkkk').each(function() {
        var $dropdown = $(this);
        var $toggle = $dropdown.find('.dropdown-toggle');
    
        // Al cargar la página, se guarda la URL original en data-href si aún no existe
        // Esto se puede usar en caso de que WordPress o Bootstrap la modifique después
        if (!$toggle.attr('data-href') || $toggle.attr('data-href') === '') {
          $toggle.attr('data-href', $toggle.attr('href'));
        }
    
        var originalHref = $toggle.attr('data-href');
        var tappedOnce = false;
        
        // Manejo del click en el enlace del dropdown
        $toggle.on('click', function(e) {
          var viewportWidth = $(window).width();
    
          if (viewportWidth >= 992) {
            // En desktop se navega directamente a la URL original
            if (originalHref && originalHref !== '#') {
              window.location.href = originalHref;
            }
          } else {
            // En móvil, el primer toque evita la navegación y muestra el menú
            if (!tappedOnce) {
              e.preventDefault();
              $dropdown.addClass('show');
              $dropdown.find('.dropdown-menu').addClass('show');
              tappedOnce = true;
              // Se resetea la variable después de 1.5 segundos
              setTimeout(function() { tappedOnce = false; }, 1500);
            } else {
              // Si es el segundo toque, se realiza la navegación
              if (originalHref && originalHref !== '#') {
                window.location.href = originalHref;
              }
            }
          }
        });
    
        // Cierra el dropdown si se hace click fuera de él
        $(document).on('click', function(e) {
          if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
            $dropdown.removeClass('show');
            $dropdown.find('.dropdown-menu').removeClass('show');
          }
        });
      });

    

   /* $('.dropdown').hover(function() {
        $(this).addClass('open');
    },
    function() {
        $(this).removeClass('open');
    });*/
    // Show dropdown on hover
$('.dropdownkkkkkk').mouseover(function () {
    if($('.navbar-toggler').is(':hidden')) {
        $(this).addClass('show').attr('aria-expanded', 'true');
        $(this).find('.dropdown-menu').addClass('show');
    }
}).mouseout(function () {
    if($('.navbar-toggler').is(':hidden')) {
        $(this).removeClass('show').attr('aria-expanded', 'false');
        $(this).find('.dropdown-menu').removeClass('show');
    }
});

// Go to the parent link on click
$('.dropdownkkkkkkkkkkkkk > a').click(function(){
    location.href = this.href;
});

    // change behaviour of controller to animate scroll instead of jump

	/*controller.scrollTo(function (newpos) {

		TweenMax.to(window, 0.5, {scrollTo: {y: newpos}});

	});*/



//  Bind scroll to anchor links

$(document).on("click", "a[href^='#']", function (e) {

    var id = $(this).attr("href");

    if ($(id).length > 0) {

        e.preventDefault();



        // trigger scroll

        controller.scrollTo(id);



            // if supported by the browser we can even update the URL.

        if (window.history && window.history.pushState) {

            history.pushState("", document.title, id);

        }

    }

});

})( jQuery );



(function($){

    $(document).ready(function($){

        /*var myCollapsible = document.getElementsByClassName('.btn-vermas')[0];
        myCollapsible.addEventListener('hidden.bs.collapse', function () {
            console.log('ver más');
        })*/
        

        $('.btn-vermas').click(function () {
            var $this = $(this);
            //$this.toggleClass('collapsed');
            if($this.hasClass('collapsed')){
                $this.text('Ver más');         
            } else {
                $this.text('Ver menos');
            }
        });   


        /*$('.btn-vermas').click(function () {

            $btnvermas = $(this);

            $id = $btnvermas.attr('data-bs-target');

            if ($btnvermas.hasClass("collapsed")) {
                $btnvermas.text('Ver más');
                console.log('ver más');
              }
              else{
                $btnvermas.text('Ver menos');
                console.log('ver menos');
              }

       

        });*/

        
        $('article.card').each(function () {

            var card = $(this);

            var id = card.attr('id');

            // build scene

            new ScrollMagic.Scene({

                triggerElement: "#" + id,

                triggerHook: 0.7,

                offset: 50, // move trigger to center of element

            })

            .setClassToggle("#"+id, "visible") // add class toggle

            .addTo(controller);

        });



        $('.cajamagic').each(function () {

            var card = $(this);

            var id = card.attr('id');

            // build scene

            new ScrollMagic.Scene({

                triggerElement: "#" + id,

                triggerHook: 0.9,

                offset: 90, // move trigger to center of element

            })

            .setClassToggle("#"+id, "visible") // add class toggle

            .addTo(controller); 

        });


        /*var scene = new ScrollMagic.Scene({triggerElement: "#trigger1", duration: 300})
        .setPin("#nav_menu-5")
        .addIndicators({name: "1 (duration: 300)"}) // add indicators (requires plugin)
        .addTo(controller);*/
        
        

      //  if ($('#ctaModal').length > 0){

      //      setTimeout(function () {

      //          $('#ctaModal').modal('show');

      //      },3000);

      //  }
      //var Sticky = require('sticky-js');
      var sticky = new Sticky('#trigger1'); 
      //var sticky = new Sticky('.data-sticky-container');
      var sticky = new Sticky('.hace-sticky'); 


    });

})( jQuery );

(function($){

    // change behaviour of controller to animate scroll instead of jump
	/*controller.scrollTo(function (newpos) {
		TweenMax.to(window, 0.5, {scrollTo: {y: newpos}});
	});*/

//  Bind scroll to anchor links
$(document).on("click", "a[href^='#']", function (e) {
    var id = $(this).attr("href");
    if ($(id).length > 0) {
        e.preventDefault();

        // trigger scroll
        controller.scrollTo(id);

            // if supported by the browser we can even update the URL.
        if (window.history && window.history.pushState) {
            history.pushState("", document.title, id);
        }
    }
});
})( jQuery );

(function($){

    // Get and autoplay Video from data
function autoPlayYouTubeModal() {
    var triggerOpen = $("body").find('[data-tagVideo]');
    triggerOpen.click(function() {
      var theModal = $(this).data("bs-target"),
        videoSRC = $(this).attr("data-tagVideo"),
        videoSRCauto = videoSRC + "?autoplay=1";
      $(theModal + ' iframe').attr('src', videoSRCauto);
      $(theModal + ' button.btn-close').click(function() {
        $(theModal + ' iframe').attr('src', videoSRC);
      });
    });
  }
  


    $(document).ready(function($){

        autoPlayYouTubeModal();
/*
        var player
var staticPlayer
function onYouTubeIframeAPIReady() {
    console.log('onYouTubeIframeAPIReady')
    player = new YT.Player('player', {
        videoId: 'M7lc1UVf-VE',
        playerVars: {
            'playsinline': 1
        },
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    })
}

function onPlayerReady(event) {
    event.target.playVideo() 
}

var done = false;
function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING && !done) {
     
    }
}

function stopVideo() {
    player.stopVideo()
}

function loadYouTubeVideo() {
    
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

}

var dynamicVideoModal = document.getElementById('dynamicVideoModal')
dynamicVideoModal.addEventListener('show.bs.modal', function (event) {
   
})
dynamicVideoModal.addEventListener('hidden.bs.modal', event => {
    player.stopVideo()
})


const playBtn = document.getElementById('playBtn')
playBtn.addEventListener('click', function (event) {
    player.playVideo()
})

const pauseBtn = document.getElementById('pauseBtn')
pauseBtn.addEventListener('click', function (event) {
    console.log('pause')
    player.pauseVideo()
})

const myModalEl = document.getElementById('videoModal')
myModalEl.addEventListener('show.bs.modal', event => {
    staticPlayer = new YT.Player('staticPlayer')
})
myModalEl.addEventListener('hidden.bs.modal', event => {
    staticPlayer.stopVideo()
})*/

        /*Ver video en modal y que se apague cuando cierras la modal */
       /* var url = $("#iframevideo").attr('src');
            $("#videoModal").on('hide.bs.modal', function() {
                $("#iframevideo").attr('src', '');
            });
            $("#videoModal").on('show.bs.modal', function() {
                $("#iframevideo").attr('src', url);
            });*/


        
        let items = document.querySelectorAll('.carousel-testimonios.carousel .carousel-item')

        items.forEach((el) => {
            const minPerSlide = 4
            let next = el.nextElementSibling
            for (var i=1; i<minPerSlide; i++) {
                if (!next) {
                    // wrap carousel by using first child
                    next = items[0]
                  }
                let cloneChild = next.cloneNode(true)
                el.appendChild(cloneChild.children[0])
                next = next.nextElementSibling
            }
        })
        

        let items2 = document.querySelectorAll('.carousel.carousel-sectores .carousel-item')

items2.forEach((el) => {
    const minPerSlide = 4
    let next = el.nextElementSibling
    for (var i=1; i<minPerSlide; i++) {
        if (!next) {
            // wrap carousel by using first child
        	next = items[0]
      	}
        let cloneChild = next.cloneNode(true)
        el.appendChild(cloneChild.children[0])
        next = next.nextElementSibling
    }
})


        /*js para menu fijo*/
        const body = document.body;
        const nav = document.querySelector("#topbar");
        const menu = document.querySelector(".widget");
        const scrollUp = "scroll-up";
        const scrollDown = "scroll-down";
        let lastScroll = 0;
        
        window.addEventListener("scroll", () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll == 0) {
            body.classList.remove(scrollUp);
            return;
        }
        
        if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
            // down
            body.classList.remove(scrollUp);
            body.classList.add(scrollDown);
        } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
            // up
            body.classList.remove(scrollDown);
            body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
        });
        /*****/

        $('article.card').each(function () {
            var card = $(this);
            var id = card.attr('id');
            // build scene
            new ScrollMagic.Scene({
                triggerElement: "#" + id,
                triggerHook: 0.7,
                offset: 50, // move trigger to center of element
            })
            .setClassToggle("#"+id, "visible") // add class toggle
            .addTo(controller);
        });

        $('.cajamagic').each(function () {
            var card = $(this);
            var id = card.attr('id');
            // build scene
            new ScrollMagic.Scene({
                triggerElement: "#" + id,
                triggerHook: 0.7,
                offset: 50, // move trigger to center of element
            })
            .setClassToggle("#"+id, "visible") // add class toggle
            .addTo(controller); 
        });

/*
        $(window).scroll(function() {
            $('#faq-accordion.not-in-viewport').each(function() {
                if ($(this).is(":in-viewport( -400 )") ) {
                    $(this).find('.collapse').collapse('hide');
                    $(this).removeClass('not-in-viewport');
                }
            });
          });
*/
        

      //  if ($('#ctaModal').length > 0){
      //      setTimeout(function () {
      //          $('#ctaModal').modal('show');
      //      },3000);
      //  }
    });
})( jQuery );